import { quickCheckout } from '@/clients/storefront/cartService';
import Button, {
  ButtonProps,
  ButtonSize,
} from '@/components/BaseLibrary/Button/Button';
import useShopifyStore from '@/data-store/hooks/useShopifyStore';

function ShopifyBuyButton(props: ButtonProps) {
  const { selectedVariantId, selectedQuantity } = useShopifyStore(
    'selectedVariantId',
    'selectedQuantity'
  );

  const handleClick = async () => {
    quickCheckout(selectedVariantId, selectedQuantity);
  };

  return <Button {...props} onClick={handleClick} size={ButtonSize.LG} />;
}

export default ShopifyBuyButton;
